import { useContext } from "react";

import { EnvHelper } from "../helpers/Environment";
import { NodeHelper } from "src/helpers/NodeHelper";

/**
 * kept as function to mimic `getMainnetURI()`
 * @returns string
 */
function getTestnetURI() {
  return EnvHelper.alchemyTestnetURI;
}

const ALL_URIs = NodeHelper.getNodesUris();
console.log("alex: ALL_URIs = ", ALL_URIs);

/**
 * "intelligently" loadbalances production API Keys
 * @returns string
 */
function getMainnetURI() {
  // Shuffles the URIs for "intelligent" loadbalancing
  const allURIs = ALL_URIs.sort(() => Math.random() - 0.5);

  // There is no lightweight way to test each URL. so just return a random one.
  // if (workingURI !== undefined || workingURI !== "") return workingURI as string;
  const randomIndex = Math.floor(Math.random() * allURIs.length);
  return allURIs[randomIndex];
}

const defaultChainId = 5;

export const addNetwork = async (chainid = defaultChainId) => {
    console.log(getMainnetURI());
    if(window.ethereum) {
       console.log("adding dyno chain")
       try {
            await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: "0x5"}]
            })
        } catch(err) {
            console.log("----------------------------", err.code);
            if(err.code === 4902) {
                await window.ethereum.request({
                    method: 'wallet_addEthereumChain',
                    params: [
                        {
                            chainName: 'Goerli',
                            chainId: "0x5",//Web3.utils.toHex(`${chainid}`),
                            nativeCurrency: {
                                name: 'Goerli Mainnet Native Token',
                                decimals: 18,
                                symbol: 'ETH'
                            },
                            rpcUrls: ["https://goerli.etherscan.io//"]
                        }
                    ]
                })
            }
        }
    }
}

export const importToken = async (tokenAddress, tokenSymbol, tokenDecimals, tokenImage) => {
    try {
        // wasAdded is a boolean. Like any RPC method, an error may be thrown.
        const wasAdded = await window.ethereum.request({
          method: 'wallet_watchAsset',
          params: {
            type: 'ERC20', // Initially only supports ERC20, but eventually more!
            options: {
              address: tokenAddress, // The address that the token is at.
              symbol: tokenSymbol, // A ticker symbol or shorthand, up to 5 chars.
              decimals: tokenDecimals, // The number of decimals in the token
              image: tokenImage, // A string url of the token logo
            },
          },
        });
      
        if (wasAdded) {
          console.log('Thanks for your interest!');
        } else {
          console.log('Your loss!');
        }
      } catch (error) {
        console.log(error);
      }
}
